module.exports = __webpack_public_path__ + "img/logo-21.22f9259b.png";